import type { FC, ReactNode } from 'react'
import type { StatusTone } from '@/components/dashboard/status-badge'

import { cn } from '@/lib/utils'

export const getHealth = (score: number): { label: string, tone: StatusTone, color: string } => {
    if (score >= 70) return { label: 'Sehat', tone: 'success', color: 'var(--success)' }
    if (score >= 40) return { label: 'Perlu perhatian', tone: 'warning', color: 'var(--warning)' }

    return { label: 'Kritis', tone: 'danger', color: 'var(--destructive)' }
}

interface HealthMeterProps {
    score: number
    showLabel?: boolean
    className?: string
}

// Health score from product usage and payment history, 0 to 100
export const HealthMeter: FC<HealthMeterProps> = ({ score, showLabel = false, className }): ReactNode => {
    const health = getHealth(score)

    return (
        <span className={cn('inline-flex items-center gap-2', className)}>
            <span className='w-7 text-right text-sm font-medium text-foreground tabular-nums'>
                {score}
            </span>

            <span className='h-1.5 w-14 overflow-hidden rounded-full bg-muted' aria-hidden='true'>
                <span className='block h-full rounded-full' style={{ width: `${score}%`, background: health.color }} />
            </span>

            {showLabel
                ? <span className='text-xs text-muted-foreground'>{health.label}</span>
                : <span className='sr-only'>{health.label}</span>}
        </span>
    )
}
